import { render, staticRenderFns } from "./HnwCopy.vue?vue&type=template&id=2bbf1b72"
import script from "./HnwCopy.vue?vue&type=script&lang=js"
export * from "./HnwCopy.vue?vue&type=script&lang=js"
import style0 from "./HnwCopy.vue?vue&type=style&index=0&id=2bbf1b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports